
import { Database } from "@/integrations/supabase/types";

export type UserRole = Database["public"]["Enums"]["user_role"];

export interface UserProfile {
  id: string;
  email: string;
  role: UserRole;
  created_at: string;
  updated_at: string;
  used_free_trial?: boolean;
  email_opt_in_at?: string | null;
}

export interface TeamInfo {
  id: string;
  team_id: string;
  user_id: string;
  created_at: string;
  updated_at: string;
}

export type TeamInfoArray = TeamInfo[];

// Helper functions for managing team information
export const isUserInTeam = (teamInfo: TeamInfoArray | TeamInfo | null, teamId: string): boolean => {
  if (!teamInfo) return false;
  
  if (Array.isArray(teamInfo)) {
    return teamInfo.some(team => (team.team_id || team.id) === teamId);
  } else {
    // Single team object
    return (teamInfo.team_id || teamInfo.id) === teamId;
  }
};

export const getPrimaryTeamId = (teamInfo: TeamInfoArray | TeamInfo | null): string | null => {
  if (!teamInfo) return null;
  
  if (Array.isArray(teamInfo)) {
    if (teamInfo.length === 0) return null;
    return teamInfo[0].team_id || teamInfo[0].id;
  } else {
    // Single team object
    return teamInfo.team_id || teamInfo.id;
  }
};
